var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsdownWhitediff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 1.66666V10.8333M18.3332 8.16666V4.33332C18.3332 3.3999 18.3332 2.93319 18.1516 2.57667C17.9918 2.26307 17.7368 2.0081 17.4232 1.84831C17.0667 1.66666 16.6 1.66666 15.6665 1.66666H6.76489C5.54699 1.66666 4.93804 1.66666 4.4462 1.88952C4.01271 2.08594 3.6443 2.40201 3.38425 2.80059C3.08919 3.25282 2.99659 3.85469 2.8114 5.05843L2.37551 7.89176C2.13125 9.47942 2.00912 10.2732 2.24472 10.8909C2.4515 11.4331 2.84042 11.8864 3.34482 12.1732C3.91949 12.5 4.72266 12.5 6.32899 12.5H6.99988C7.46659 12.5 7.69995 12.5 7.87821 12.5908C8.03501 12.6707 8.16249 12.7982 8.24239 12.955C8.33321 13.1333 8.33321 13.3666 8.33321 13.8333V16.2785C8.33321 17.4133 9.25321 18.3333 10.3881 18.3333C10.6588 18.3333 10.9041 18.1739 11.014 17.9266L13.8146 11.6251C13.942 11.3385 14.0057 11.1952 14.1064 11.0901C14.1954 10.9973 14.3047 10.9262 14.4257 10.8826C14.5626 10.8333 14.7194 10.8333 15.033 10.8333H15.6665C16.6 10.8333 17.0667 10.8333 17.4232 10.6517C17.7368 10.4919 17.9918 10.2369 18.1516 9.92331C18.3332 9.56679 18.3332 9.10008 18.3332 8.16666Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsdownWhitediff);
export default __webpack_public_path__ + "static/media/thumbsdownWhitediff.f5e6325a86d05480e8111691f86b8d6d.svg";
export { ForwardRef as ReactComponent };